module.exports = __webpack_public_path__ + "static/order-117cab0d180abd960a9a464b5855d83c.jpg";